import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

import Loader from "../../Components/Common/Loader";

import { adminGetAllShift } from "helpers/backend_helpers";
import { formatDateTime } from "helpers/globalFunction";
import AddModalShift from "./AddModalShift";
import DeleteModalShift from "./DeleteModalShift";
import StatusModalShift from "./StatusModalShift";
import UpdateModalShift from "./UpdateModalShift";
import QrOpenModal from "./QrOpenModal";
import QrCloseModal from "./QrCloseModal";

const ShiftList = () => {
  const user: any = JSON.parse(sessionStorage.getItem("user") || "null");
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [addModal, setAddModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [statusModal, setStatusModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState<boolean>(false);

  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterName, setFilterName] = useState<string>("");
  const [searchName, setSearchName] = useState<string>("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchName(filterName);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [filterName]);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (searchName) {
      query.name = searchName;
    }

    adminGetAllShift(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            let dibuat = formatDateTime(el.createTime);
            let diperbarui = formatDateTime(el.updateTime);
            const values = el.category;
            const labels = comboCategory
              .filter((item) => values?.includes(item.value))
              .map((item) => item.label);
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              dibuat,
              diperbarui,
              toleransi: el.tolerance + " menit",
              kategori: labels.join(", "),
            };
          }),
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResetFilter = () => {
    setFilterName("");
    setSearchName("");
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
      },
      {
        header: "Nama Shift",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Kategori",
        accessorKey: "kategori",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Jam Mulai Absen",
        accessorKey: "startOpen",
        enableColumnFilter: false,
        enableSorting: false,
        size: 120,
      },
      {
        header: "Jam Masuk",
        accessorKey: "checkInTime",
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
      },
      {
        header: "Jam Pulang",
        accessorKey: "checkOutTime",
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
      },
      {
        header: "Toleransi Terlambat",
        accessorKey: "toleransi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 120,
      },
      {
        header: "Status",
        accessorKey: "isActive",
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
        cell: (cell: any) => {
          switch (cell.getValue()) {
            case true:
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  Aktif
                </span>
              );
            case false:
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  Tidak Aktif
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase bg-info-subtle text-info">
                  -
                </span>
              );
          }
        },
      },
      {
        header: "Dibuat",
        accessorKey: "dibuat",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Diperbarui",
        accessorKey: "diperbarui",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Aksi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              {user.companyAttendanceType !== "SELFIE" ||
                (user.attendanceType !== "SELFIE" && (
                  <>
                    <UncontrolledTooltip
                      target={`checkin-${cellProps.row.original._id}`}
                    >
                      Lihat QR Absen Masuk
                    </UncontrolledTooltip>
                    <button
                      id={`checkin-${cellProps.row.original._id}`}
                      className="btn btn-sm btn-soft-success"
                      onClick={() => {
                        setOpenModal(true);
                        setData(cellProps.row.original);
                      }}
                    >
                      <i className="mdi mdi-door-open" />
                    </button>

                    <UncontrolledTooltip
                      target={`checkout-${cellProps.row.original._id}`}
                    >
                      Lihat QR Absen Keluar
                    </UncontrolledTooltip>
                    <button
                      id={`checkout-${cellProps.row.original._id}`}
                      className="btn btn-sm btn-soft-secondary"
                      onClick={() => {
                        setCloseModal(true);
                        setData(cellProps.row.original);
                      }}
                    >
                      <i className="mdi mdi-door-closed" />
                    </button>
                  </>
                ))}

              <UncontrolledTooltip
                target={`status-${cellProps.row.original._id}`}
              >
                Ubah Status
              </UncontrolledTooltip>
              <button
                id={`status-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  setStatusModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="mdi mdi-list-status" />
              </button>

              <UncontrolledTooltip
                target={`edit-${cellProps.row.original._id}`}
              >
                Edit
              </UncontrolledTooltip>
              <button
                id={`edit-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-warning edit-list"
                onClick={() => {
                  setUpdateModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-pencil-fill align-bottom" />
              </button>

              <UncontrolledTooltip
                target={`delete-${cellProps.row.original._id}`}
              >
                Hapus
              </UncontrolledTooltip>
              <button
                id={`delete-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-danger remove-list"
                onClick={() => {
                  setDeleteModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-delete-bin-5-fill align-bottom" />
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  const comboCategory = [
    { value: "EMPLOYEE", label: "EMPLOYEE" },
    { value: "SECURITY", label: "SECURITY" },
    { value: "CLEANING_SERVICE", label: "CLEANING SERVICE" },
    { value: "OFFICE_BOY", label: "OFFICE BOY" },
    { value: "DRIVER", label: "DRIVER" },
    { value: "GARDENER", label: "GARDENER" },
  ];

  useEffect(() => {
    getData();
  }, [pagination, sort, dir, searchName]);

  document.title = "Shift";

  return (
    <React.Fragment>
      <div className="page-content">
        <AddModalShift
          show={addModal}
          onCloseClick={() => setAddModal(false)}
          getData={() => getData()}
        />

        <UpdateModalShift
          show={updateModal}
          onCloseClick={() => setUpdateModal(false)}
          getData={() => getData()}
          data={data}
        />

        <StatusModalShift
          show={statusModal}
          onCloseClick={() => setStatusModal(false)}
          getData={() => getData()}
          data={data}
        />

        <DeleteModalShift
          show={deleteModal}
          onCloseClick={() => setDeleteModal(false)}
          getData={() => getData()}
          data={data}
          setData={() => setData({})}
        />

        <QrOpenModal
          show={openModal}
          onCloseClick={() => setOpenModal(false)}
          data={data}
        />

        <QrCloseModal
          show={closeModal}
          onCloseClick={() => setCloseModal(false)}
          data={data}
        />

        <Container fluid>
          <BreadCrumb title="Data Shift" pageTitle="Shift" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">Shift</h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        <div
                          className="btn btn-soft-success btn-sm"
                          onClick={() => {
                            setAddModal(true);
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          Tambah
                        </div>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={4}>
                        <div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Cari nama shift..."
                            value={filterName}
                            onChange={(e) => setFilterName(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ShiftList;
